<template>
  <div class="overlay-loader">
    <div v-for="component in renderedComponents" :key="`overlay-${component.id}`">
      <keep-alive>
        <component :is="component.is" v-bind="component.props" />
      </keep-alive>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import overlayStore, { URL_PARAMS_TO_SHOW_OVERLAYS } from '@/stores/overlay'
import DynamicYieldService from '@/api/services/_shared/dynamic-yield-service'
import { registerStores } from '@/helpers/stores'
import { getQueryFromUrl } from '@/helpers/url'

export default {
  name: 'OverlayLoader',

  computed: {
    ...mapGetters({
      renderedComponents: 'overlay/renderedComponents',
      hasVisibleOverlays: 'overlay/hasVisibleOverlays',
    }),
  },

  watch: {
    hasVisibleOverlays: {
      immediate: true,
      handler() {
        this.toggleDocumentOverflow(!this.hasVisibleOverlays)
      },
    },
  },

  beforeCreate() {
    registerStores({ overlay: overlayStore })
  },

  mounted() {
    this.showOverlaysBasedOnUrlParams()
    this.showDynamicOverlayIfAny()
  },

  methods: {
    ...mapActions({
      preloadOverlay: 'overlay/preload',
      showOverlay: 'overlay/show',
      showDynamicOverlay: 'overlay/showDynamicOverlay',
      toggleDocumentOverflow: 'page/toggleDocumentOverflow',
    }),

    async showOverlaysBasedOnUrlParams() {
      for (const id in URL_PARAMS_TO_SHOW_OVERLAYS) {
        if (getQueryFromUrl(URL_PARAMS_TO_SHOW_OVERLAYS[id])) {
          const delay = Number(getQueryFromUrl('delay'))
          const preloadPromise = this.preloadOverlay(id)
          const show = async () => {
            await preloadPromise
            await this.$nextTick()
            this.showOverlay(id)
          }
          delay ? setTimeout(show, delay * 1000) : show()
        }
      }
    },

    async showDynamicOverlayIfAny() {
      const data = await DynamicYieldService.fetchDynamicOverlay()
      if (data?.dynamicOverlay) {
        const props = data.dynamicOverlay
        if (props.closeCookieLifetime === null) delete props.closeCookieLifetime
        delete props.__typename
        this.showDynamicOverlay(props)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.overlay-loader {
  position: fixed;
  top: 0;
  left: 0;
  z-index: $navigation-z-index + 1;
}
</style>
